import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as DiscoverIcon } from "../../inlineSvgs/discover-grey.svg";
import { ReactComponent as DiscoverColorIcon } from "../../inlineSvgs/discover.svg";
import { ReactComponent as CalendarIcon } from "../../inlineSvgs/calendar-grey.svg";
import { ReactComponent as CalendarColorIcon } from "../../inlineSvgs/calendar-3.svg";
import { ReactComponent as ProfileIcon } from "../../inlineSvgs/profile-grey.svg";
import { ReactComponent as ProfileColorIcon } from "../../inlineSvgs/profile.svg";

const MobileNavigation = () => {
  const setClassName = ({ isActive }) => (isActive ? "mob-nav__item active" : "mob-nav__item");

  return (
    <div className="mob-nav">
      <NavLink to="/" end className={setClassName}>
        <span className="gray">
          <DiscoverIcon />
        </span>
        <span className="color">
          <DiscoverColorIcon />
        </span>
        <span>Discover</span>
      </NavLink>
      <NavLink to="/orders" end className={setClassName}>
        <span className="gray">
          <CalendarIcon />
        </span>
        <span className="color">
          <CalendarColorIcon />
        </span>
        <span>Booking</span>
      </NavLink>
      <NavLink to="/profile" end className={setClassName}>
        <span className="gray">
          <ProfileIcon />
        </span>
        <span className="color">
          <ProfileColorIcon />
        </span>
        <span>Profile</span>
      </NavLink>
    </div>
  );
};

export default MobileNavigation;
